module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <BalanzaComprobacion-consultar></BalanzaComprobacion-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/balanzaComprobacion/balanzaComprobacion.component.html
// module id = ./src/app/Contabilidad/balanzaComprobacion/balanzaComprobacion.component.html
// module chunks = main